// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"26767197","453":"de4dd3aa","455":"120fa68a","977":"4b00d4d8"}[chunkId] + ".chunk.js";
};